import { ApolloProvider } from '@apollo/client';
import { Elements } from '@stripe/react-stripe-js';
import { ThemeProvider } from '@podiumhq/design-system';
import { ErrorBoundary } from '@sentry/react';
import { loadStripe } from '@stripe/stripe-js';
import ErrorView from './components/ErrorView';
import GlobalSnackbar from './lib/GlobalSnackbar';
import env from 'env';
import RoutesComponent from './routes';
import GlobalStyles from './lib/GlobalStyles';
import subscriptionsClient from 'lib/apollo/clients/subscriptions';

const stripePromise = loadStripe(env.STRIPE_PUBLIC_KEY);

function App() {
  return (
    <ErrorBoundary fallback={<ErrorView />}>
      <ApolloProvider client={subscriptionsClient}>
        <Elements
          stripe={stripePromise}
          fonts={[
            {
              cssSrc: 'https://assets.podium.com/fonts/Graphik-Regular.woff',
            },
          ]}
        >
          <ThemeProvider resetCSS>
            <GlobalStyles>
              <RoutesComponent />
            </GlobalStyles>
          </ThemeProvider>
        </Elements>
      </ApolloProvider>
      <GlobalSnackbar />
    </ErrorBoundary>
  );
}

export default App;
